import * as React from "react";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores";
import { observer } from "mobx-react";
import { API } from "General/API";
import { formatUserIdToName } from "utils/mentionHelpers/formatUserIdToName";
import { QACommentsView } from "./QACommentsView";
import { SuggestionsConfig } from "./AddCommentForm";

interface QAQuestionCommentsProps {
  questionId: number;
  canFetch: boolean;
  suggestions: SuggestionsConfig;
}

interface QAQuestionCommentsState {
  comments: API_Comment[];
}

export const QAQuestionComments = observer(
  class QAQuestionComments extends React.Component<QAQuestionCommentsProps, QAQuestionCommentsState> {
    constructor(props: QAQuestionCommentsProps) {
      super(props);

      this.state = {
        comments: [
          // {
          //   comment: 'Test comment for display some text',
          //   id: 1,
          //   dateCreated: '523215213434',
          //   ownerId: 3
          // }
        ],
      };
    }

    componentDidMount() {
      if (this.props.canFetch) {
        (async () => await this.fetchComments())();
      }
    }

    componentDidUpdate(prevProps: QAQuestionCommentsProps) {
      if (!prevProps.canFetch && this.props.canFetch) {
        this.fetchComments();
      }
    }

    fetchComments = async () => {
      try {
        // questionGetComments??
        const url = API_URL.QA.questionAddComment(projectsDataStore.projectId, this.props.questionId);
        const response: API_Comment[] = await API.getData(url);
        const comments = response.map(({ comment, ...rest }) => ({ comment: formatUserIdToName(comment), ...rest }));
        this.setState({ comments: comments });
      } catch (error) {
        throw error;
      }
    };

    addComment = async (comment: string) => {
      try {
        const url = API_URL.QA.questionAddComment(projectsDataStore.projectId, this.props.questionId);
        const response: API_Comment = await API.newData(url, { comment });
        this.setState({
          comments: this.state.comments.concat({ ...response, comment: formatUserIdToName(response.comment) }),
        });
      } catch (error) {
        throw error;
      }
    };

    render() {
      const { comments } = this.state;
      if (!this.props.canFetch) {
        return null;
      }

      return <QACommentsView data={comments} onSubmit={this.addComment} suggestions={this.props.suggestions} />;
    }
  }
);
